/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.ScoreCard.DomainRow.vue?vue&type=template&id=4d9b923b&scoped=true"
import script from "./Program.ScoreCard.DomainRow.vue?vue&type=script&lang=js"
export * from "./Program.ScoreCard.DomainRow.vue?vue&type=script&lang=js"
import style0 from "./Program.ScoreCard.DomainRow.vue?vue&type=style&index=0&id=4d9b923b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9b923b",
  null
  
)

export default component.exports